// @ts-strict-ignore
import {Translatable} from 'common/i18n';
import {
  END_OF_TODAY,
  END_OF_YESTERDAY,
  START_OF_MONTH,
  START_OF_QUARTER,
  START_OF_TODAY,
  START_OF_WEEK,
  START_OF_YEAR,
  START_OF_YESTERDAY,
} from 'common/widgets/date-range-picker/models/presets';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {getDateRangeLabel} from 'common/widgets/date-range-picker-new/util';
import {getCurrentMoment} from 'common/util/date';

export function getDateRangeLabelForDashboardCards({
  dateRange,
  asString = false,
}: {
  dateRange: DateRange;
  asString?: boolean;
}): Translatable {
  if (dateRange.from === START_OF_YESTERDAY && dateRange.to === END_OF_YESTERDAY) {
    return `yesterday`;
  }

  if (dateRange.from === START_OF_TODAY && dateRange.to === END_OF_TODAY) {
    return `today`;
  }

  const dateLabel = getDateRangeLabel({
    dateRange,
    matchingPreset: null,
    projectAsOfDate: null,
    now: getCurrentMoment({localized: true}),
    formatMode: `simple`,
    asString,
  });
  return dateLabel;
}

export function getXToDateText(fromDate: string) {
  if (fromDate === START_OF_WEEK) {
    return `since start of week`;
  } else if (fromDate === START_OF_MONTH) {
    return `since start of month`;
  } else if (fromDate === START_OF_QUARTER) {
    return `since start of quarter`;
  } else if (fromDate === START_OF_YEAR) {
    return `since start of year`;
  } else {
    return `invalid date`;
  }
}
